<template>
  <section>
    <div>
      <div class="second-image">
        <SeoHero
          :left-image="
            require('~/assets/images/illustrations/commuter-left.png')
          "
          :right-image="
            require('~/assets/images/illustrations/svg/Right Side Background.svg')
          "
          left-position="-180px"
          right-position="100px"
          left-position-desktop="-130px"
          bike-type="triathlon"
          @cta="handleClick"
        >
          Insurance For Triathletes
        </SeoHero>
      </div>
      <div class="container">
        <Featured />
        <Triathlon />
        <WhyYouCanPedalsure />
        <BlogWidget
          title="Learn more about our insurance"
          :slugs="[
            'which-cycling-insurance-is-best-for-me',
            '7-reasons-why-every-cyclist-should-get-cycling-insurance',
            'does-home-insurance-cover-my-bike',
            'does-travel-insurance-cover-cycling',
          ]"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import Featured from '@/components/homepage/Featured'
import Triathlon from '@/components/commuter/Triathlon'
import SeoHero from '@/components/seo/SeoHero'
import WhyYouCanPedalsure from '@/components/triathlon/WhyYouCanPedalsure'
import BlogWidget from '@/components/blog-widget/BlogWidget'
import { buildSocialMeta, resolveSocialImage } from '@/helpers/social-meta'
import { productOffer } from '@/helpers/product-offer'

// og:image and Product.image both read this, so the two cannot drift apart.
const OG_IMAGE_PATH = '/images/og/triathlon-cycle-insurance-1200x630.png'

// The bike this page is about: drives the CTA href and the modal prefill.
const BIKE_TYPE = 'triathlon'

export default {
  name: 'TriathlonCycleInsurance',
  components: {
    Featured,
    Triathlon,
    WhyYouCanPedalsure,
    BlogWidget,
    SeoHero,
  },
  data() {
    return {
      page: {
        title: 'Insurance For Triathletes | Pedalsure',
        meta_description:
          'Triathlon specific insurance you can rely on from Pedalsure. We cover your bike (including in transition) against theft, accidental damage and loads more.',
      },
    }
  },
  head() {
    return {
      title: this.page.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.page.meta_description,
        },
        { hid: 'title', name: 'title', content: this.page.title },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'commuter insurance, road, cycling',
        },
        ...buildSocialMeta({
          title: this.page.title,
          description: this.page.meta_description,
          path: this.$route.path,
          image: OG_IMAGE_PATH,
          type: 'website',
        }).meta,
      ],
      script: [
        {
          innerHTML: `
        {
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "Triathlon Bike Insurance",
          "logo": "https://www.pedalsure.com/Pedalsure-Logo_Large.svg",
          "image": ${JSON.stringify([resolveSocialImage(OG_IMAGE_PATH)])},
          "description": "Triathlon specific insurance you can rely on from Pedalsure. We cover your bike (including in transition) against theft, accidental damage and loads more.",
           "brand": {
            "@type": "Brand",
            "name": "Pedalsure"
          },
          "offers": ${JSON.stringify(productOffer())}
        }
        `,
          type: 'application/ld+json',
        },
      ],
    }
  },
  methods: {
    ...mapActions('quote', {
      resetQuote: 'resetQuote',
    }),
    handleClick() {
      this.resetQuote()
      // Same values the CTA's href carries, so a quote started from the modal
      // is attributed identically to one started by following the link.
      this.$modal.show('quick-quote', {
        bikeType: BIKE_TYPE,
        src: `lp-${BIKE_TYPE}`,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}
</style>

<style lang="scss" scoped>
/* Hero styling now lives in components/seo/SeoHero.vue */
</style>
